import {
  Button as MuiButton,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import _, { toLower, upperFirst } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { pictos } from '../assets/img/pictos';
import Chemin from '../components/Chemin';
import ErrorPopup from '../components/ErrorPopup';
import Navigation from '../components/Navigation';
import SearchInput from '../components/SearchInput';
import { PoliceDefaut, PoliceDefautBold } from '../helpers/contants';
import { stripHtml } from '../helpers/functions';
import {
  participantsRedux,
  programmeSelectRedux,
  programmesRedux,
} from '../redux/evenementsServices';
import { refreshToken } from '../redux/profilService';
import '../styles/programme.css';
import textConnect from '../textConnect.json';
import { couleurTheme, pictosCategorie, toNormalForm, formatTimeTo24h } from './fonctions';
import { setProgrammeFilter, setProgrammesNavigation } from '../redux/evenementsSlice';
import { ProgrammeListSkeleton } from '../components/skeletons';

const Programme = () => {
  const location = useLocation();
  //Breadcrumbs
  const breadCrumbs = useSelector(state => state.profil.chemin);
  const breadcrumbs_temp = breadCrumbs.filter(item => item.nom === 'Accueil');
  breadcrumbs_temp.push({ url: location.pathname, nom: 'Programme' });

  const evenementSelected = useSelector(state => state.evenements.evenementSelect);
  const programmeFilterSaved = useSelector(state => state.evenements.programmeFilter);
  const programmesData = useSelector(state => state.evenements.programmes);
  const leProgrammeInit = React.useMemo(() => {
    const normalized = Array.isArray(programmesData)
      ? programmesData.map(item => ({
          ...item,
          titre: item?.titre ?? '',
          description: item?.description ?? '',
          theme: item?.theme ?? '',
          categorie: {
            ...(item?.categorie || {}),
            label: item?.categorie?.label ?? '',
          },
        }))
      : [];
    return _.sortBy(normalized, ['heure_deb']);
  }, [programmesData]);
  const [leProgramme, setLeProgramme] = useState(leProgrammeInit);

  const monProfil = useSelector(state => state.profil.profil);

  const AccessToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);
  const dispatch = useDispatch();
  const navigationPage = useNavigate();

  const [filtreMot, setFiltreMot] = useState(programmeFilterSaved?.filtreMot ?? '');

  const [loading, setLoading] = useState(true);
  const showLoading = useDelayedLoading(loading, 500);

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);

  //Fonction filtre barre de recherche
  function filtreProgrammes(e) {
    setFiltreMot(e.target.value);
    console.log(filtreMot);
  }

  function annulerFiltre() {
    setLeProgramme(leProgrammeInit);
    setAnchorEl(null);
    setCatCheck([]);
    setThemeCheck([]);
  }

  // Menu filtre
  const [catCheck, setCatCheck] = useState(programmeFilterSaved?.catCheck ?? []);
  const [themeCheck, setThemeCheck] = useState(programmeFilterSaved?.themeCheck ?? []);
  const savedCatCheckRef = React.useRef([]);
  const savedThemeCheckRef = React.useRef([]);
  const savedFiltreMotRef = React.useRef(programmeFilterSaved?.filtreMot ?? '');
  useEffect(() => {
    dispatch(setProgrammeFilter({ catCheck, themeCheck, filtreMot, page: 1 }));
  }, [dispatch, catCheck, themeCheck, filtreMot]);

  function FiltrerCategorie(categorie = [], tableau = [], themesSelection = []) {
    let resultat = [];
    if (categorie.length > 1) {
      let tabTemp = [];
      for (let index = 0; index < categorie.length; index++) {
        tableau
          .filter(item => item.categorie.label.includes(categorie[index]))
          .map(item2 => tabTemp.push(item2));
        resultat = tabTemp;
      }
    } else {
      resultat = tableau.filter(item => item.categorie.label.includes(categorie));
    }
    if (themesSelection.length > 0) {
      const themeNorm = t => toNormalForm((t || '').toLowerCase());
      const selectedNorm = new Set(themesSelection.map(t => themeNorm(t)));
      resultat = resultat.filter(item => selectedNorm.has(themeNorm(item.theme)));
    }
    setLeProgramme(resultat);
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    savedCatCheckRef.current = [...catCheck];
    savedThemeCheckRef.current = [...themeCheck];
    savedFiltreMotRef.current = filtreMot;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setCatCheck(savedCatCheckRef.current);
    setThemeCheck(savedThemeCheckRef.current);
    setFiltreMot(savedFiltreMotRef.current);
    setAnchorEl(null);
  };
  const handleApplyClose = () => {
    setAnchorEl(null);
  };
  // Unique categories, sorted alphabetically
  const leProgrammeUnique = [
    ...new Map(leProgrammeInit.map(item => [item.categorie.label, item])).values(),
  ].sort(function (a, b) {
    if (upperFirst(a.categorie.label) < upperFirst(b.categorie.label)) {
      return -1;
    }
    if (upperFirst(a.categorie.label) > upperFirst(b.categorie.label)) {
      return 1;
    }
    return 0;
  });

  // Unique themes from programmes, sorted alphabetically
  const leProgrammeUniqueThemes = [
    ...new Set(
      leProgrammeInit
        .map(item => (item.theme != null && item.theme !== '' ? item.theme : null))
        .filter(Boolean)
    ),
  ].sort((a, b) =>
    upperFirst(toLower(a)) < upperFirst(toLower(b))
      ? -1
      : upperFirst(toLower(a)) > upperFirst(toLower(b))
      ? 1
      : 0
  );

  const handleCheck = (e, value) => {
    if (e.target.checked) {
      setCatCheck(old => [...old, value]);
    } else {
      setCatCheck(catCheck.filter(item => item !== value));
      console.log(catCheck);
    }
  };
  useEffect(() => {
    dispatch({
      type: 'Profil/addChemin',
      payload: breadcrumbs_temp,
    });
    FiltrerCategorie(catCheck, leProgrammeInit, themeCheck);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catCheck, themeCheck, leProgrammeInit]);
  const participantsList = (token, id) => {
    participantsRedux(token, id)
      .then(reponse => {
        // setLoading(false)
        dispatch({
          type: 'evenements/addParticipants',
          payload: reponse.data,
        });
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        // setLoading(false)
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              participantsList(token, id);
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };
  const programSelect = (token, id) => {
    setLoading(true);
    participantsList(token, evenementSelected.id);
    programmeSelectRedux(token, id)
      .then(reponse => {
        dispatch({
          type: 'evenements/addProgrammeSelect',
          payload: reponse.data,
        });
        // window.open('/programmeDetail', '_top')
        navigationPage('/programme/' + id + '/0');
        setLoading(false);
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              programSelect(token, id);
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };

  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');

  const closeErrorHandle = () => {
    setOpenError(false);
  };
  useEffect(() => {
    setLoading(true);
    programmesRedux(AccessToken, evenementSelected.id)
      .then(async response => {
        dispatch({
          type: 'evenements/addProgramme',
          payload: response.data,
        });
        if (location.pathname !== '/programmes') {
          navigationPage('/programmes', { replace: true });
        }
        setLoading(false);
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container fluid>
      <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />
      <Menu
        className="menu-filtre"
        id="filtre-menu"
        aria-labelledby="btn-filtre"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            minWidth: 260,
            width: 260,
            maxWidth: 260,
          },
        }}
      >
        <Typography className="mx-3 border-bottom" style={{ fontFamily: PoliceDefautBold }}>
          {' Filtrer par catégorie :'}
        </Typography>
        {leProgrammeUnique.map((item, index) =>
          item.categorie.label === '' || item.categorie.label === null ? null : (
            <MenuItem
              key={index}
              className=""
              style={{ fontFamily: PoliceDefaut, cursor: 'pointer' }}
              onClick={e => {
                e.stopPropagation();
                handleCheck(
                  {
                    target: {
                      checked: catCheck.filter(cat => cat === item.categorie.label).length === 0,
                    },
                  },
                  item.categorie.label
                );
              }}
            >
              <Col
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleCheck(
                    {
                      target: {
                        checked: catCheck.filter(cat => cat === item.categorie.label).length === 0,
                      },
                    },
                    item.categorie.label
                  );
                }}
              >
                <label
                  htmlFor={`category-${index}-${item.categorie.label}`}
                  style={{ cursor: 'pointer', marginBottom: 0 }}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCheck(
                      {
                        target: {
                          checked:
                            catCheck.filter(cat => cat === item.categorie.label).length === 0,
                        },
                      },
                      item.categorie.label
                    );
                  }}
                >
                  {upperFirst(toLower(item.categorie.label))}
                </label>
              </Col>
              <Col className="" sm="auto" onClick={e => e.stopPropagation()}>
                <input
                  id={`category-${index}-${item.categorie.label}`}
                  checked={catCheck.filter(cat => cat === item.categorie.label).length > 0}
                  type="checkbox"
                  name=""
                  onChange={e => handleCheck(e, item.categorie.label)}
                  onClick={e => e.stopPropagation()}
                />
              </Col>
            </MenuItem>
          )
        )}
        {leProgrammeUniqueThemes.length > 0 ? (
          <>
            <Typography
              className="mx-3 mt-2 border-bottom"
              style={{ fontFamily: PoliceDefautBold }}
            >
              Filtrer par thématique :
            </Typography>
            <MenuItem disableRipple sx={{ display: 'block' }} onClick={e => e.stopPropagation()}>
              <FormControl fullWidth size="small" sx={{ minWidth: 220 }}>
                <InputLabel id="programme-theme-select-label" style={{ fontFamily: PoliceDefaut }}>
                  Thématiques
                </InputLabel>
                <Select
                  labelId="programme-theme-select-label"
                  multiple
                  value={themeCheck}
                  label="Thématiques"
                  onChange={e => setThemeCheck(e.target.value)}
                  renderValue={selected =>
                    selected.length === 0
                      ? 'Aucune'
                      : selected.length <= 2
                      ? selected.map(t => upperFirst(toLower(t))).join(', ')
                      : `${selected.length} sélectionnée(s)`
                  }
                  MenuProps={{
                    disableScrollLock: true,
                    PaperProps: { sx: { maxHeight: 220 } },
                  }}
                  sx={{ fontFamily: PoliceDefaut }}
                >
                  {leProgrammeUniqueThemes.map(themeLabel => (
                    <MenuItem key={themeLabel} value={themeLabel}>
                      <Checkbox
                        checked={themeCheck.indexOf(themeLabel) > -1}
                        sx={{ padding: '4px 8px 4px 0' }}
                      />
                      <ListItemText
                        primary={upperFirst(toLower(themeLabel))}
                        primaryTypographyProps={{ fontFamily: PoliceDefaut }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </MenuItem>
          </>
        ) : null}
        <MenuItem className="border-top py-2" sx={{ display: 'block' }} disableRipple>
          <Row className="g-2 w-100 m-0">
            <Col xs={6} className="p-0 pr-1">
              <MuiButton
                fullWidth
                variant="contained"
                size="small"
                onClick={() => handleApplyClose()}
                sx={{
                  fontFamily: PoliceDefautBold,
                  borderRadius: 0,
                  textTransform: 'none',
                }}
              >
                Afficher {leProgramme?.length ?? 0}
              </MuiButton>
            </Col>
            <Col xs={6} className="p-0 pl-1">
              <MuiButton
                fullWidth
                variant="outlined"
                size="small"
                onClick={() => annulerFiltre()}
                sx={{
                  fontFamily: PoliceDefaut,
                  borderRadius: 0,
                  textTransform: 'none',
                }}
              >
                Réinitialiser
              </MuiButton>
            </Col>
          </Row>
        </MenuItem>
      </Menu>
      <Row>
        <Navigation
          button={true}
          titre={'Programme'}
          icone={pictos.programme_rond_icone}
          evenement={evenementSelected.photo}
          photo={monProfil.photo_path}
          retour="dashboard"
          selected={5}
          open={(!open).toString()}
          menus={true}
        />
      </Row>

      <Row className="p-0">
        <Chemin breadCrumbs={breadcrumbs_temp} />
      </Row>
      <Row className="programme-container d-flex justify-content-center">
        {showLoading ? (
          <ProgrammeListSkeleton count={6} />
        ) : (
          <>
            {leProgrammeInit.length > 0 ? (
              <Row className=" mb-4 d-flex align-items-center justify-content-center">
                <SearchInput
                  placeholder={'Rechercher'}
                  filtre={filtreProgrammes}
                  value={filtreMot}
                />

                <Col sm="auto" xl={''} className="" style={{ width: 'fit-content' }}>
                  <NavLink
                    style={{ textDecoration: 'none', color: '#134491' }}
                    aria-controls={open ? 'filtre-menu' : undefined}
                    aria-haspopup={true}
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                  >
                    <Row
                      className="d-flex justify-content-center"
                      style={{
                        textAlign: 'center',
                        height: '20px',
                        margin: '',
                      }}
                    >
                      {' '}
                      {'Filtrer'}{' '}
                    </Row>
                    <img
                      className="row"
                      src={pictos.filtrer_icone}
                      alt=""
                      style={{ width: '30px', margin: 'auto' }}
                    />
                  </NavLink>
                </Col>
              </Row>
            ) : null}

            <Row xs={1} className="d-flex align-items-center justify-content-center">
              {leProgramme.length ? (
                leProgramme.filter(item => {
                  return filtreMot.toLowerCase() === ''
                    ? item
                    : toNormalForm(item.titre.toLowerCase()).includes(
                        toNormalForm(filtreMot.toLowerCase())
                      ) ||
                        toNormalForm(item.description.toLowerCase()).includes(
                          toNormalForm(filtreMot.toLowerCase())
                        ) ||
                        toNormalForm(item.theme.toLowerCase()).includes(
                          toNormalForm(filtreMot.toLowerCase())
                        );
                }).length === 0 ? (
                  <p
                    className=""
                    style={{
                      textAlign: 'center',
                      color: '#134491',
                      fontSize: '120%',
                    }}
                  >
                    Aucun résultat trouvé
                  </p>
                ) : (
                  leProgramme
                    .filter(item => {
                      return filtreMot.toLowerCase() === ''
                        ? item
                        : toNormalForm(item.titre.toLowerCase()).includes(
                            toNormalForm(filtreMot.toLowerCase())
                          ) ||
                            toNormalForm(item.description.toLowerCase()).includes(
                              toNormalForm(filtreMot.toLowerCase())
                            ) ||
                            toNormalForm(item.theme.toLowerCase()).includes(
                              toNormalForm(filtreMot.toLowerCase())
                            );
                    })
                    .map((item, index) => (
                      <Row key={index} className="programme-item ">
                        <Col className="">
                          <Row className="d-flex align-items-center">
                            <Col
                              sm="auto   "
                              className="programme-date"
                              style={{
                                backgroundColor: couleurTheme(item.categorie),
                                marginLeft: '10px',
                              }}
                            >
                              {item.heure_fin === '' ||
                              item.heure_fin === undefined ||
                              item.heure_fin === null
                                ? formatTimeTo24h(item.heure_deb)
                                : `${formatTimeTo24h(item.heure_deb)} - ${formatTimeTo24h(
                                    item.heure_fin
                                  )}`}
                            </Col>

                            <Col className="stand1 p-0" style={{ width: '' }}>
                              {item.categorie.for_room ? (
                                (item.stand.id === '' || item.stand.id === undefined) &&
                                item.salle === '' ? null : (
                                  <div className=" d-flex align-items-center">
                                    <img
                                      title={
                                        item.stand.id === undefined || item.stand.id === ''
                                          ? null
                                          : 'Voir le stand'
                                      }
                                      onClick={() =>
                                        navigationPage(
                                          item.stand.id === undefined || item.stand.id === ''
                                            ? ''
                                            : '/planStand/' + item.stand.id
                                        )
                                      }
                                      src={pictos.lieu_icone}
                                      alt=""
                                      style={{
                                        height: '25px',
                                        width: 'auto',
                                        cursor:
                                          item.stand.id === undefined || item.stand.id === ''
                                            ? ''
                                            : 'pointer',
                                      }}
                                    />
                                    <div className=" pt-1 d-flex align-items-center">{`${upperFirst(
                                      toLower(item.salle)
                                    )}`}</div>
                                  </div>
                                )
                              ) : item.stand.code === '' || item.stand.code === undefined ? null : (
                                <div className="d-flex align-items-center">
                                  <img
                                    title="Voir le stand"
                                    onClick={() =>
                                      navigationPage(
                                        item.stand.id === undefined || item.stand.id === ''
                                          ? ''
                                          : '/planStand/' + item.stand.id
                                      )
                                    }
                                    src={pictos.lieu_icone}
                                    alt=""
                                    style={{
                                      height: '25px',
                                      width: 'auto',
                                      cursor: 'pointer',
                                    }}
                                  />
                                  <div className=" pt-1 d-flex align-items-center">{`${upperFirst(
                                    toLower(item.stand.code)
                                  )}`}</div>
                                </div>
                              )}
                            </Col>
                            <img
                              className="col-sm-auto px-2 mt-3"
                              src={pictosCategorie(item.categorie)}
                              alt=""
                              style={{
                                height: '',
                                width: 'auto',
                                paddingRight: '0',
                                paddingLeft: '0',
                              }}
                            />
                          </Row>
                          <div
                            className=""
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              // Get the filtered list
                              const filteredProgrammes = leProgramme.filter(item => {
                                return filtreMot.toLowerCase() === ''
                                  ? item
                                  : toNormalForm(item.titre.toLowerCase()).includes(
                                      toNormalForm(filtreMot.toLowerCase())
                                    ) ||
                                      toNormalForm(item.description.toLowerCase()).includes(
                                        toNormalForm(filtreMot.toLowerCase())
                                      ) ||
                                      toNormalForm(item.theme.toLowerCase()).includes(
                                        toNormalForm(filtreMot.toLowerCase())
                                      );
                              });

                              // Find index in filtered list
                              const indexInFiltered = filteredProgrammes.findIndex(
                                p => p.id === item.id
                              );
                              const programmeIds = filteredProgrammes.map(p => p.id);

                              dispatch(
                                setProgrammesNavigation({
                                  ids: programmeIds,
                                  currentIndex: indexInFiltered,
                                })
                              );

                              programSelect(AccessToken, item.id);
                            }}
                          >
                            <Row className="mb-1" style={{ marginTop: '-12px' }}>
                              <Row className="stand2">
                                <Col className=" p-0  mb-1 px-1" style={{ width: '' }}>
                                  {item.categorie.for_room ? (
                                    (item.stand.id === '' || item.stand.id === undefined) &&
                                    item.salle === '' ? null : (
                                      <div className="d-flex align-items-center">
                                        <img
                                          title={
                                            item.stand.id === undefined || item.stand.id === ''
                                              ? null
                                              : 'Voir le stand'
                                          }
                                          onClick={() =>
                                            navigationPage(
                                              item.stand.id === undefined || item.stand.id === ''
                                                ? ''
                                                : '/planStand/' + item.stand.id
                                            )
                                          }
                                          src={pictos.lieu_icone}
                                          alt=""
                                          style={{
                                            height: '25px',
                                            width: 'auto',
                                            cursor:
                                              item.stand.id === undefined || item.stand.id === ''
                                                ? ''
                                                : 'pointer',
                                          }}
                                        />
                                        <div className=" pt-1 d-flex align-items-center">{`${upperFirst(
                                          toLower(item.salle)
                                        )}`}</div>
                                      </div>
                                    )
                                  ) : item.stand.code === '' ||
                                    item.stand.code === undefined ? null : (
                                    <div className="d-flex align-items-center">
                                      <img
                                        title="Voir le stand"
                                        onClick={() =>
                                          navigationPage(
                                            item.stand.id === undefined || item.stand.id === ''
                                              ? ''
                                              : '/planStand/' + item.stand.id
                                          )
                                        }
                                        src={pictos.lieu_icone}
                                        alt=""
                                        style={{
                                          height: '25px',
                                          width: 'auto',
                                          cursor: 'pointer',
                                        }}
                                      />
                                      <div className=" pt-1 d-flex align-items-center">{`${upperFirst(
                                        toLower(item.stand.code)
                                      )}`}</div>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                              <Col
                                sm="auto"
                                className=""
                                style={{ color: couleurTheme(item.categorie) }}
                              >
                                {item.categorie.label === '' ||
                                item.categorie.label === 'Rendez-vous'
                                  ? upperFirst(toLower(item.theme))
                                  : item.theme === '' || item.theme === null
                                  ? upperFirst(toLower(item.categorie.label))
                                  : `${upperFirst(toLower(item.categorie.label))} - ${upperFirst(
                                      toLower(item.theme)
                                    )}`}
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                className="programme-titre"
                                style={{ color: couleurTheme(item.categorie) }}
                              >
                                {upperFirst(toLower(item.titre))}
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                className="programme-description programme-description-text"
                                style={{
                                  display: '-webkit-box',
                                  WebkitLineClamp: '2',
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                <p className="programme-description-text">
                                  {upperFirst(stripHtml(item.description))}
                                </p>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    ))
                )
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    textAlign: 'center',
                    width: '100%',
                    minHeight: 120,
                    color: '#134491',
                    fontSize: '150%',
                  }}
                >
                  Pas de programme
                </div>
              )}
            </Row>
          </>
        )}
      </Row>
    </Container>
  );
};

export default Programme;
